/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from '../styles';
import SeoPageNewEditForm from 'src/sections/@dashboard/seoPage/SeoPageNewEditForm';
import { SeoPage } from '../../../../@types/seoPage';

type SeoPageModalProps = {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentSeoPage: SeoPage | undefined;
};

export const SeoPageModal = ({ open, handleClose, isEdit, currentSeoPage }: SeoPageModalProps) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <SeoPageNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentSeoPage={currentSeoPage}
        />
      </StyledModalBox>
    </Modal>
  );
};
